<template>
  <Input
         v-model="defaultValue"
         :class="prefixCls"
         v-bind="$attrs"
         :rows="rows || 10"
         :size="size"
         v-on="$listeners"
         @change="onChange"
         @blur="onBlur"
  >
    <template slot="prepend">
      <slot name="prepend" />
    </template>
    <slot></slot>
  </Input>
</template>

<script>
import {Input} from 'element-ui'
import {useGlobSetting} from '~/hooks/useGlobSetting'
import {insertStep} from "~/utils/event";

export default {
  name: "BaseInput",
  components: {
    Input
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    keys: {
      type: Array,
      default() {
        return []
      }
    },
    targetKey: {
      type: String,
      default: ''
    },
    modelKey: {
      type: String,
      default: ''
    },
    targetIndex: {
      type: [String, Number],
      default: '',
    },
    rows:{
      type: [String, Number],
      default: 10,
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  data() {
    const {prefixCls} = useGlobSetting()
    return {
      defaultValue: '',
      prefixCls: prefixCls + '-input'
    }
  },
  watch:{
    value(val){
      this.defaultValue = val
    }
  },
  created() {
    this.defaultValue = this.value
  },
  methods: {
    onChange() {
      insertStep(this, [...this.keys, this.modelKey, this.targetIndex, this.targetKey], this.value)
      this.$emit('change', this.value)
    },
    onBlur() {
      this.$emit('input', this.defaultValue)
    }
  }
}
</script>

<style lang="less" scoped>
@prefix-cls: ~'@{namespace}-input';
.@{prefix-cls} {
  /deep/ span.el-input__count, span.el-input__count-inner {
    border: none !important;
    background-color: transparent;
    &:hover {
      border: none !important;
    }
  }
  /deep/ span.el-input__suffix {
    border: none !important;
  }
  & > :hover{
    border-color: rgba(255, 255, 255, 0.2) !important;
  }
  /deep/ .el-input-group__prepend {
    background-color: rgba(255, 255, 255, 0.05);
    border: none;
  }
  /deep/ input  {
    background: rgba(255, 255, 255, 0.05);
    color: rgba(255, 255, 255, 0.8);
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    font-size: 13px;
    font-weight: normal;
    height: 36px;
    line-height: 36px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    padding-left: 12px;
    
    &:focus {
        border-color: var(--primary-color);
        background: rgba(255, 255, 255, 0.08);
        color: #fff;
        box-shadow: 0 0 0 2px rgba(var(--primary-color-rgb), 0.2);
    }
    &:hover {
      border-color: rgba(255, 255, 255, 0.2);
      background: rgba(255, 255, 255, 0.08);
    }
  }
    /deep/ textarea {
      background: rgba(255, 255, 255, 0.05);
      color: rgba(255, 255, 255, 0.8);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 8px;
      font-size: 13px;
      padding: 8px 12px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

      &:focus {
        border-color: var(--primary-color);
        background: rgba(255, 255, 255, 0.08);
        color: #fff;
        box-shadow: 0 0 0 2px rgba(var(--primary-color-rgb), 0.2);
      }
      
      &:hover {
        border-color: rgba(255, 255, 255, 0.2);
        background: rgba(255, 255, 255, 0.08);
      }
    }
}
</style>